import axios from 'axios';
import router from '@/router';
import store from '@/store';

import { getErrorObject } from '@/assets/js/utility';
import { defaultSRID } from '@/assets/js/variables';

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 0,
  headers: {},
});

instance.interceptors.request.use(config => {
  const { data, noWrap } = config;
  if (!noWrap) {
    if (data) {
      config.data = { data };
    }
  }
  const { token, sessionId } = store.state.authentication;
  if (token) {
    config.headers['X-Access-Token'] = token;
  }
  if (sessionId) {
    config.headers['X-WebSocket-ID'] = sessionId;
  }
  config.headers['X-Response-SRID'] = defaultSRID;
  return config;
});

instance.interceptors.response.use(
  config => {
    return config;
  },
  error => {
    const errorObject = getErrorObject(error);
    if (errorObject.isShowSnackbar) {
      store.set('snackbar/PUSH_ERROR!', errorObject);
    }
    if (errorObject.isLogout) {
      router.push({ name: 'login', query: { redirect: router.currentRoute.fullPath } });
    }
    if (!errorObject.skipDefaultErrorHandler) {
      store.dispatch('gtag/createEvent', {
        action: 'exception',
        category: 'api_request',
        label: errorObject.message,
        params: {
          type: errorObject.type,
        },
      });
    }
    throw new Error(errorObject.message);
  }
);

export default instance;
